(function () {
  let isInitialized = false;
  let rafId = null;

  function initGiftValidation() {
    if (isInitialized) return;

    const giftFieldContainers = document.querySelectorAll(
      ".gift-fields-required"
    );
    const checkoutBtn = document.getElementById("CartDrawer-Checkout");

    if (!giftFieldContainers.length || !checkoutBtn) return;

    isInitialized = true;

    const touchedFields = new WeakSet();

    function validateEmail(email) {
      const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return re.test(email);
    }

    function validateAllGiftFields(showErrors = true) {
      let allValid = true;

      giftFieldContainers.forEach((container) => {
        const emailInput = container.querySelector(".gift-email-input");
        const noteInput = container.querySelector(".gift-note-input");
        const emailError = container.querySelector('[data-error-for^="email"]');
        const noteError = container.querySelector('[data-error-for^="note"]');

        if (!emailInput || !noteInput) return;

        const emailValue = emailInput.value.trim();
        const noteValue = noteInput.value.trim();
        const emailTouched = touchedFields.has(emailInput);
        const noteTouched = touchedFields.has(noteInput);

        if (!emailValue) {
          allValid = false;
          if (showErrors && emailTouched) {
            emailInput.classList.add("error");
            if (emailError) {
              emailError.classList.add("show");
            }
          }
        } else if (!validateEmail(emailValue)) {
          allValid = false;
          if (showErrors && emailTouched) {
            emailInput.classList.add("error");
            if (emailError) {
              emailError.textContent = "Please enter a valid email address";
              emailError.classList.add("show");
            }
          }
        } else {
          emailInput.classList.remove("error");
          if (emailError) {
            emailError.classList.remove("show");
          }
        }

        const emailIsValid = emailValue && validateEmail(emailValue);

        if (!noteValue) {
          allValid = false;
          if (showErrors && (noteTouched || emailIsValid)) {
            noteInput.classList.add("error");
            if (noteError) noteError.classList.add("show");
          }
        } else {
          noteInput.classList.remove("error");
          if (noteError) noteError.classList.remove("show");
        }
      });

      const currentCheckoutBtn = document.getElementById("CartDrawer-Checkout");
      if (currentCheckoutBtn) {
        if (allValid) {
          currentCheckoutBtn.classList.remove("disabled-gift");
          currentCheckoutBtn.disabled = false;
        } else {
          currentCheckoutBtn.classList.add("disabled-gift");
          currentCheckoutBtn.disabled = true;
        }
      }

      return allValid;
    }

    function throttledValidate() {
      if (rafId !== null) {
        cancelAnimationFrame(rafId);
      }
      rafId = requestAnimationFrame(validateAllGiftFields);
    }

    checkoutBtn.classList.add("disabled-gift");
    checkoutBtn.disabled = true;
    validateAllGiftFields(false);

    giftFieldContainers.forEach((container) => {
      const emailInput = container.querySelector(".gift-email-input");
      const noteInput = container.querySelector(".gift-note-input");
      const charCounter = container.querySelector(".char-count");

      if (emailInput) {
        emailInput.addEventListener("focus", function () {
          touchedFields.add(emailInput);
        });
        emailInput.addEventListener("input", function () {
          touchedFields.add(emailInput);
          throttledValidate();
        });
        emailInput.addEventListener("blur", function () {
          touchedFields.add(emailInput);
          validateAllGiftFields(true);
        });
      }

      if (noteInput) {
        noteInput.addEventListener("focus", function () {
          touchedFields.add(noteInput);
        });
        noteInput.addEventListener("input", function () {
          touchedFields.add(noteInput);
          if (charCounter) {
            charCounter.textContent = this.value.length;
          }
          throttledValidate();
        });
        noteInput.addEventListener("blur", function () {
          touchedFields.add(noteInput);
          validateAllGiftFields(true);
        });
      }
    });

    const form = document.getElementById("CartDrawer-Form");
    if (form) {
      form.addEventListener("submit", function (e) {
        giftFieldContainers.forEach((container) => {
          const emailInput = container.querySelector(".gift-email-input");
          const noteInput = container.querySelector(".gift-note-input");
          if (emailInput) touchedFields.add(emailInput);
          if (noteInput) touchedFields.add(noteInput);
        });

        if (!validateAllGiftFields(true)) {
          e.preventDefault();
          const firstInvalidContainer = document.querySelector(
            ".gift-fields-required .gift-email-input.error, .gift-fields-required .gift-note-input.error"
          );
          if (firstInvalidContainer) {
            firstInvalidContainer
              .closest(".gift-fields-required")
              .scrollIntoView({ behavior: "smooth", block: "center" });
          }
        }
      });
    }

    checkoutBtn.addEventListener("click", function (e) {
      giftFieldContainers.forEach((container) => {
        const emailInput = container.querySelector(".gift-email-input");
        const noteInput = container.querySelector(".gift-note-input");
        if (emailInput) touchedFields.add(emailInput);
        if (noteInput) touchedFields.add(noteInput);
      });

      if (!validateAllGiftFields(true)) {
        e.preventDefault();
        e.stopPropagation();
        const firstInvalidContainer = document.querySelector(
          ".gift-fields-required .gift-email-input.error, .gift-fields-required .gift-note-input.error"
        );
        if (firstInvalidContainer) {
          firstInvalidContainer
            .closest(".gift-fields-required")
            .scrollIntoView({ behavior: "smooth", block: "center" });
        }
      }
    });
  }

  function resetInitialization() {
    isInitialized = false;
    if (rafId !== null) {
      cancelAnimationFrame(rafId);
      rafId = null;
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initGiftValidation);
  } else {
    initGiftValidation();
  }

  const cartDrawer = document.querySelector("cart-drawer");
  if (cartDrawer) {
    const observer = new MutationObserver(function (mutations) {
      let shouldReinit = false;
      mutations.forEach(function (mutation) {
        if (mutation.addedNodes.length > 0) {
          mutation.addedNodes.forEach(function (node) {
            if (node.nodeType === 1) {
              if (
                node.classList &&
                node.classList.contains("gift-fields-required")
              ) {
                shouldReinit = true;
              } else if (
                node.querySelector &&
                node.querySelector(".gift-fields-required")
              ) {
                shouldReinit = true;
              }
            }
          });
        }
        if (mutation.removedNodes.length > 0) {
          mutation.removedNodes.forEach(function (node) {
            if (node.nodeType === 1) {
              if (
                node.classList &&
                node.classList.contains("gift-fields-required")
              ) {
                resetInitialization();
              } else if (
                node.querySelector &&
                node.querySelector(".gift-fields-required")
              ) {
                resetInitialization();
              }
            }
          });
        }
      });

      if (shouldReinit) {
        resetInitialization();
        requestAnimationFrame(initGiftValidation);
      }
    });

    observer.observe(cartDrawer, {
      childList: true,
      subtree: true,
    });
  }
})();
